import { useState } from "react";
import { Task } from "@common/types/task";

interface SelectedTaskLocation {
    taskId: string;
    workspaceId: string;
}

interface UseSelectedTaskWorkspaceIdParams {
    tasks: Task[];
    selectedTaskId: string | null;
}

export function useSelectedTaskWorkspaceId({
    tasks,
    selectedTaskId,
}: UseSelectedTaskWorkspaceIdParams) {
    const [lastSelectedTask, setLastSelectedTask] =
        useState<SelectedTaskLocation | null>(null);
    const listedWorkspaceId = tasks.find(
        (task) => task.id === selectedTaskId,
    )?.workspaceId;

    const isLastSelectedTaskStale =
        lastSelectedTask?.taskId !== selectedTaskId ||
        lastSelectedTask?.workspaceId !== listedWorkspaceId;
    if (selectedTaskId && listedWorkspaceId && isLastSelectedTaskStale) {
        setLastSelectedTask({
            taskId: selectedTaskId,
            workspaceId: listedWorkspaceId,
        });
    }

    if (listedWorkspaceId) {
        return listedWorkspaceId;
    }

    return lastSelectedTask?.taskId === selectedTaskId
        ? lastSelectedTask.workspaceId
        : undefined;
}
